import React from 'react';
import Entry from '../entry';
import { Flex, Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = '7. Get Access To The Steam Tunnels';
  const flag = 'Krampus Hollyfeld';
  const hints = [(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Minty Candycane] </Text><a rel="noopener noreferrer" target="_blank" href='https://github.com/deviantollam/decoding'>Deviant's Key Decoding Templates</a></Flex>),
   (<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Minty Candycane] </Text><a rel="noopener noreferrer" target="_blank" href='https://www.youtube.com/watch?v=KU6FJnbkeLA&feature=youtu.be'>Optical Decoding of Keys</a></Flex>),
 '[Minty Candycane Chat] Have you played with the key grinder in my room? Check it out! It turns out: if you have a good image of a key, you can physically copy it. Maybe you\'ll see someone hopping around with a key here on campus. Sometimes you can find it in the Network tab of the browser console. Deviant has a great talk on it at this year\'s Con. He even has a collection of key bitting templates for common vendors like Kwikset, Schlage, and Yale.'
];
  const assignment = 'Gain access to the steam tunnels. Who took the turtle doves? Please tell us their first and last name. For hints on achieving this objective, please visit Minty\'s dorm room and talk with Minty Candy Cane.'
  const data = useStaticQuery(graphql`
    query {
      krampus: file(relativePath: { eq: "krampus1.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      key: file(relativePath: { eq: "key.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      makeKey: file(relativePath: { eq: "makeKey.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      tunnel: file(relativePath: { eq: "tunnel.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      fullNameKrampus: file(relativePath: { eq: "fullNameKrampus.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }

    }
  `)
  return (
    <Entry
      title={title}
      hints={hints}
      flag={flag}
      assignment={assignment}
    >
      <Text my={2}>As Minty said, we find something interesting in the Network tab of browser Dev tools when we enter her room. It's Krampus with key!</Text>
      <Img fluid={data.krampus.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}> With the help of DeviantOllam's Decoding templates we can determine that the make of the key is Schlage. Using Keynote (on Mac) we overlay the key with Schlage.png from Decoding Repo. </Text>
      <Img fluid={data.key.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '70vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Now that we know the code, we can make the key with his code.</Text>
      <Img fluid={data.makeKey.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>The key opens the lock and we are inside the Steam Tunnels.</Text>
      <Img fluid={data.tunnel.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>After a little walking we meet Krampus who admits to taking the doves temporarily:</Text>
      <Img fluid={data.fullNameKrampus.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '35vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
    </Entry>
  )

};
